<template>
  <div :class="`stats-name-wrap stats-name-wrap__`+statusData" >
    <span class="stats-number">{{statusCounter}}</span>
    <span class="arrow-up" v-if="isClosed && lastCounter < statusCounter"></span>
    <span class="arrow-down" v-if="isClosed && lastCounter > statusCounter"></span>
    <br>
    <div class="stats-bar" v-if="!isClosed" :style="{backgroundColor: statusColor}"></div>
    <div class="stats-bar" v-else :style="{backgroundColor: statusColor}"></div>
    <span class="stats-name"> {{statusName}}</span>
</div>
</template>
<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  props: ["statusData", ],
  data() {
    return {
      statusCounter: 0,
      statusName: "",
      lastCounter: 0,
      isClosed: false,
      addHoursToUTC:6,
      maxDays:14,
      statusColor:"#4C9850",
        filterQuery: {
                sort: "",
                query: "",
                filterByDate: false,
                filterByTaskDate: false,
                filterByDateCreated: false,
                dateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                taskDateRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                dateCreatedRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                dateCompletedRange: {
                startDate: new Date(),
                endDate: new Date(),
                },
                status: [],
                outlet: [],
                deliverableType: [],
                tag: [],
                department: [],
                coordinator: [],
                project: [],
                noDepartment: "not_accepted",
                noOutlet: "not_accepted",
                weekFilterOptions: {
                    overdue: false,
                    today: false,
                    thisWeek: false,
                    nextWeek: false,
                    upcoming: false,
                    noDeadline: false,
                },
                dashboardType: 'numberSet',
            },
    };
  },
  computed: {
    ...mapGetters([
        "numberStat"
    ])
  },
  create(){
    //   this.fetchList();

  },
  async mounted() {
      // console.log("props : statusData", this.statusData)
    await this.fetchList();

    this.timer = setInterval(this.fetchList, 10000);

      Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
        if ( this.statusData == "closed_today" || this.statusData == "closed_past7days" || this.statusData == "closed_past31days" || this.statusData =="closed_today"){
            if ( e.deliverable.completed_at != null){
            this.fetchList();
            }
        }
		});
        let tryCount = 0;
		Echo.channel('task').listen('TaskUpdated', (e) => {
             if ( this.statusData == "today_progress" || this.statusData == "today_pending" || this.statusData == "today_waiting" || this.statusData =="closed_today"){

                tryCount = tryCount +1;
                // if ( tryCount == 10){
                    this.fetchList();
                    tryCount = 0;
                // }
             }
		});


  },
  methods: {
      ...mapActions([
			"fetchNumberStat",
		]),
        async fetchList(){


  this.filterQuery.dashboardType =this.statusData;
    let status = {};
     if ( this.statusData == "today_progress"){
         this.filterQuery.status.push({name: "Awaiting Approval", color: "#FFA500"});
         this.filterQuery.status.push({name: "In Progress", color: "#8A2BE2"});
         this.filterQuery.status.push({name: "Pending Completion", color: "#483D8B"});

         let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
         let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
         this.filterQuery.dateCreatedRange.startDate = fromDate.format();
         this.filterQuery.dateCreatedRange.endDate = endDate.format();
         this.filterQuery.filterByDateCreated = true;

      }else if (this.statusData == "today_pending"){
        status = {name: "Pending Completion", color: "#483D8B"}
        this.filterQuery.status.push(status);

        let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
        let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
        this.filterQuery.dateCreatedRange.startDate = fromDate.format();
        this.filterQuery.dateCreatedRange.endDate = endDate.format();
        this.filterQuery.filterByDateCreated = true;

      }else if (this.statusData == "today_waiting"){
        status = {name: "Awaiting Approval", color: "#FFA500"}
        this.filterQuery.status.push(status);

        let fromDate = this.$moment.utc().subtract(this.maxDays, 'days');
        let endDate = this.$moment.utc().add(this.addHoursToUTC, 'hours');
        this.filterQuery.dateCreatedRange.startDate = fromDate.format();
        this.filterQuery.dateCreatedRange.endDate = endDate.format();
        this.filterQuery.filterByDateCreated = true;
      }

      this.filterQuery.deliverableType = [];
      this.filterQuery.deliverableType.push(
      {
      	"id": "media_call",
      	"name": "Media Call",
      	"typeIcon": "media-call",
      	"typeId": 1
      }
      );



   		 this.$store.commit("setDashboardMediaCallsFilter", this.filterQuery);
       let data = await this.fetchNumberStat();
       // console.log("dNumberStat component data ", data);
      	this.$nextTick(() => {

        if ( this.statusData == "today_progress"){
            this.statusCounter = this.numberStat.count;
            this.statusName = "in progress";
            this.statusColor = this.numberStat.color
      }else if (this.statusData == "today_pending"){
           this.statusCounter = this.numberStat.count;
            this.statusName = "pending completion";
             this.statusColor = this.numberStat.color
      }else if (this.statusData == "today_waiting"){
           this.statusCounter = this.numberStat.count;
            this.statusColor = this.numberStat.color
            this.statusName = "waiting for approval";
      }else if (this.statusData == "closed_today"){
            this.statusCounter = this.numberStat.count;
             this.lastCounter = this.numberStat.lastCount;
            this.statusName = "today";
            this.isClosed =true;
      }else if (this.statusData == "closed_past7days"){
            this.statusCounter = this.numberStat.count;
             this.lastCounter = this.numberStat.lastCount;
            this.statusName = "past 7 days";
            this.isClosed =true;
     }else if (this.statusData == "closed_past31days"){
             this.statusCounter = this.numberStat.count;
              this.lastCounter = this.numberStat.lastCount;
            this.statusName = "past 31 days";
            this.isClosed =true;
      }else{

      }


    })

        }
  }
};
</script>

<style>
</style>
